var path = '/templates/projects.campaigns/show_clearance.html';
var html = "<div ng-if=!clearanceItemSet><div class=big_icon><i class=\"fa fa-list\"></i></div><div class=campaign_notset>{{ 'projectsCampaigns.clearance.notFound' | translate }}</div></div><div ng-if=clearanceItemSet><zc-clearance-item-list project=currentProject clearance-item-set=clearanceItemSet></zc-clearance-item-list></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.campaigns/show_clearance.html
// module id = 1395
// module chunks = 0